import {Component, OnInit} from "@angular/core";
import {LoadScriptService} from "../../../../../projects/shared/src/lib/load-script.service";
import {NGXLogger} from "ngx-logger";
import {FlexLayoutModule} from "@ngbracket/ngx-layout";
import {MatButton} from "@angular/material/button";
import {MatDialogActions, MatDialogContent, MatDialogTitle} from "@angular/material/dialog";
import {UserService} from "../../../domain/user/service/user.service";

@Component({
  selector: 'app-auto-billing-dialog',
  standalone: true,
  templateUrl: './auto-billing-dialog.component.html',
  imports: [
    FlexLayoutModule,
    MatButton,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions
  ],
  providers: [LoadScriptService],
})
export class AutoBillingDialogComponent implements OnInit {
  info: any;

  constructor(private log: NGXLogger,
              private readonly userService: UserService) {
  }

  ngOnInit(): void {
    // this.autoBillingService.getBillingInfo()
    //   .subscribe(response => {
    //     this.info = response;
    //   });
  }

  requestBillingKey(method: 'CARD' | 'TRANSFER') {
    // this.userService.getSessionUser()
    //   .subscribe(user => {
    //     this.autoBillingService.requestBillingKey(method, user.username)
    //   })
  }

  deleteBillingKey() {
    // this.autoBillingService.deleteBillingKey()
    //   .subscribe(() => {
    //     this.info = null;
    //   });
  }
}
